import { toCamel } from "@/helpers/humps";
import type { FeatureKeys, Features } from "@/models/features";
import { API_BASE, callApi } from "@/services/api";

// Intentionally does not swallow a rejected callApi — a transient failure
// must propagate so callers (useFeatures) can leave the store unloaded and
// retry later, instead of caching a false "no flags" result for the session.
export async function fetchFeatures(keys: FeatureKeys[]): Promise<Features> {
  const resp = await callApi(
    `${API_BASE}/features?${keys
      .map((k) => `key[]=${encodeURIComponent(k)}`)
      .join("&")}`,
  );
  return transformFeatures(keys, resp as unknown as Record<string, unknown>);
}

const transformFeatures = (
  keys: FeatureKeys[],
  resp: Record<string, unknown>,
): Features => {
  const features: Record<string, boolean> = {};
  for (const key of keys) {
    const camelKey = toCamel(key);
    const value = resp?.[camelKey];
    if (value === true || value === "true") {
      features[camelKey] = true;
    } else if (value === false || value === "false") {
      features[camelKey] = false;
    }
  }
  return features as Features;
};
